import { useEffect, useState } from "react";
import { useStore } from "../webar-core/framework/store/Store";
// import { userActivatedAR } from "../../framework/utils/gtag";
import "../styles/componentStyles/StyledPermissionComponent.scss";
import cn from "../languages/cn";

export function StyledPermission(props: any) {
  const [modalAnimateIn, setModalAnimateIn] = useState(false);
  const [modalAnimateOut, setModalAnimateOut] = useState(false);
  const [allowButtonClicked, setAllowButtonClicked] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setModalAnimateIn(true);
    }, 8000);
  }, []);

  return (
    <div id="permissionContainer">
      <div
        id="permissionModal"
        className={`${modalAnimateIn ? "animateIn" : "hiddenZ"} ${
          modalAnimateOut ? "animateOut" : ""
        }`}
      >
        <div
          id="motionSensorsPopUpText"
          dangerouslySetInnerHTML={{
            __html: props.translate
              ? cn.motionSensorsPopUpText.text
              : "AR requires access to device<br/>motion sensors and camera",
          }}
        ></div>
        <div className="buttonsWrapper">
          <button
            id="motionSensorsNo"
            className="cancel"
            onClick={() => {
              props.setPermissionsDenied(true);
            }}
          >
            <span
              id="motionSensorSpanNo"
              style={{ whiteSpace: props.translate ? "nowrap" : "normal" }}
            >
              {props.translate ? cn.motionSensorSpanNo.text : "Cancel"}
            </span>
          </button>
          <button
            id="motionSensorsYes"
            className={`allow ${allowButtonClicked ? "active" : ""}`}
            onClick={
              () => {
                setAllowButtonClicked(true);
                setTimeout(() => {
                  useStore.getState().setAskPermissions(true);
                }, 800);
                setTimeout(() => {
                  setModalAnimateOut(true);
                }, 500);
              }
              // userActivatedAR();
            }
          >
            <img
              className="highlight"
              src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/loadingPage/gradientSwipe.png"
              alt=""
            ></img>
            <span id="motionSensorSpanYes">
              {props.translate ? cn.motionSensorSpanYes.text : "Continue"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
